import { EntityApiService } from '@dfl/react-security';
import { IBlockCause } from 'modules/crm/settings/block-cause/interfaces';

class BlockCauseService extends EntityApiService<IBlockCause> {}

export default new BlockCauseService('/ms-auth/api/customer-block-causes');
